module.exports = __webpack_public_path__ + "static/img/ptzu.058a499.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/company/ptzu.png
// module id = L2iI
// module chunks = 3